const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR';

const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
const GET_PROJECTS_ERROR = 'GET_PROJECTS_ERROR';

const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';

const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR';

const EDIT_PROJECT_REQUEST = 'EDIT_PROJECT_REQUEST';
const EDIT_PROJECT_SUCCESS = 'EDIT_PROJECT_SUCCESS';
const EDIT_PROJECT_ERROR = 'EDIT_PROJECT_ERROR';

const CLEAR_PROJECTS_STATE = 'CLEAR_PROJECTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';
const CLEAR_CREATE_STATE = 'CLEAR_CREATE_STATE';

const CREATE_ERRORS = 'CREATE_ERRORS';

export {
  GET_PROJECT_REQUEST,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_ERROR,
  GET_PROJECTS_REQUEST,
  GET_PROJECTS_SUCCESS,
  GET_PROJECTS_ERROR,
  CREATE_PROJECT_REQUEST,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_ERROR,
  EDIT_PROJECT_REQUEST,
  EDIT_PROJECT_SUCCESS,
  EDIT_PROJECT_ERROR,
  DELETE_PROJECT_REQUEST,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_ERROR,
  CLEAR_PROJECTS_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  CLEAR_CREATE_STATE,
  INIT_REDUCER,
};
